module.exports = __webpack_public_path__ + "static/media/banner-tecnologia-fisk.40840a2d.png";